
  import { Vue, Component, Prop } from "vue-property-decorator";
  import S3Image from "@/components/common/s3-image.vue";
  import SchedulerItemAvatar from "@/components/scheduler/SchedulerItemAvatar.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import ColorCodeTriangle from "@/components/scheduler/ColorCodeTriangle.vue";
  import Tooltip from "@/components/common/Tooltip.vue";

  import getFullName from "@/helpers/getFullName";
  import ContractorViewActivity from "@/entities/scheduler/ContractorViewActivity";
  import ContractorViewItemEntityInfo from "@/entities/scheduler/ContractorViewItemEntityInfo";
  import { Manager } from "@/generated/graphql";
  import getAvatarPadding from "@/helpers/scheduler/getAvatarPadding";
  import TooltipVariants from "@/entities/TooltipVariants";
  import { NOT_ASSIGNED } from "@/data/placeholders";

  @Component({
    components: {
      S3Image,
      SchedulerItemAvatar,
      ColorCodeTriangle,
      Tooltip,
      UiButton,
    }
  })
  export default class ContractorViewActivityItem extends Vue {
    @Prop({ type: Object, default: () => ({}) }) readonly activity!: ContractorViewActivity;
    @Prop({ type: Array, default: () => [] }) readonly overlappingActivityIds!: string[];

    TooltipVariants = TooltipVariants;

    get isNewlyCreatedItem(): boolean {
      return Boolean(!this.activity?.entityInfo);
    }

    get activityInfo(): ContractorViewItemEntityInfo | undefined {
      return this.activity?.entityInfo || undefined;
    }

    get activityOverlaps(): boolean {
      return this.overlappingActivityIds.includes(this.activity.id);
    }

    get projectManager(): Manager | undefined {
      return this.activityInfo?.project?.manager || undefined;
    }

    get activityName(): string {
      return this.activityInfo?.activity?.title || "";
    }

    get projectName(): string {
      return this.activityInfo?.project?.name || "";
    }

    get managerName(): string {
      if (this.isNewlyCreatedItem) {
        return "";
      }
      if (!this.projectManager) {
        return NOT_ASSIGNED;
      }
      const managerUser = this.projectManager.user;
      return getFullName(managerUser.given_name!, managerUser.family_name!);
    }

    get projectInfo(): string {
      return `Project: ${this.projectName}. Manager: ${this.managerName}`;
    }

    get avatarsPadding(): string {
      return getAvatarPadding(this.colorCode);
    }

    get hoursNeedApproval(): boolean {
      return Boolean(this.activityInfo?.activity?.requested_hours && !this.activityInfo.activity.confirmed_hours);
    }

    get colorCode(): string {
      if (this.activityOverlaps) {
        return "danger";
      }
      if (this.hoursNeedApproval) {
        return "warning";
      }
      return "";
    }

    get tooltipTitle(): string {
      if (this.activityOverlaps) {
        return "Task dates are overlapping with another task";
      }
      if (this.hoursNeedApproval) {
        return "Task has requested hours that need confirming"
      }
      return "";
    }
  }
